import { FC, ReactNode } from 'react';
import { useFormContext, get } from 'react-hook-form';
import styled from 'styled-components';
import { Colors } from '../../../assets';
import { FontSize, FontWeight, Spacing } from '../../../assets/GlobalStyle/Variables';

type TextareaProps = {
  id: string;
  name: string;
  label: ReactNode;
  disabled?: boolean;
  rows: number;
  required?: boolean;
};

export const Textarea: FC<TextareaProps> = (props) => {
  const { id, name, disabled = false, label, rows, required = false } = props;

  const methods = useFormContext();

  return (
    <StyledTextareaWrapper>
      {label && (<StyledLabel htmlFor={id}>{label}:{required && ' *'} </StyledLabel>)}
      <StyledTextareaInputWrapper>
        <StyledTextarea id={id} disabled={disabled} rows={rows} $hasError={!!get(methods.formState.errors, name)} {...methods.register(name, { required })} />
        {required && get(methods.formState.errors, name)?.type === 'required' && (
          <span role="alert">Povinné pole</span>
        )}
      </StyledTextareaInputWrapper>    
    </StyledTextareaWrapper>
  );
};

const StyledTextareaWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: ${Spacing(8)};
`;

const StyledTextareaInputWrapper = styled.div`
  width: 100%;

  span[role='alert'] {
    display: block;
    margin: 2px 0;
    color: ${Colors.error};
    font-size: ${FontSize.small};
  }
`;

const StyledTextarea = styled.textarea<{ $hasError?: boolean }>`
  margin: 0px;
  padding: 0 ${Spacing(8)};
  border: 1px solid ${(props) => (props.$hasError ? Colors.error : Colors.disabledHover)};
  line-height: 40px;
  height: auto;
  box-sizing: border-box;
  width: 100%;
  border-radius: 0px;
  color: ${Colors.grey};
  font-size: ${FontSize.normal};

  &:focus {
    outline: none;
    border: 1px solid ${(props) => (props.$hasError ? Colors.error : Colors.disabledHover)};
  }
`;

const StyledLabel = styled.label`
  margin: 0;
  color: ${Colors.grey};
  font-weight: ${FontWeight.strong};
  font-size: ${FontSize.normal};
  min-width: 200px;
`;
